var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsDateString, IsOptional, IsString, MaxLength } from 'class-validator';
export class UpdateOfficeLocationNewsDto {
    title;
    text;
    publishStart;
    publishEnd;
}
__decorate([
    IsOptional(),
    MaxLength(255),
    IsString(),
    __metadata("design:type", String)
], UpdateOfficeLocationNewsDto.prototype, "title", void 0);
__decorate([
    IsOptional(),
    MaxLength(2000),
    IsString(),
    __metadata("design:type", String)
], UpdateOfficeLocationNewsDto.prototype, "text", void 0);
__decorate([
    IsOptional(),
    IsDateString(),
    __metadata("design:type", Date)
], UpdateOfficeLocationNewsDto.prototype, "publishStart", void 0);
__decorate([
    IsOptional(),
    IsDateString(),
    __metadata("design:type", Date)
], UpdateOfficeLocationNewsDto.prototype, "publishEnd", void 0);
//# sourceMappingURL=update-office-location-news.dto.js.map